import { formatNumeric } from '@common/utils'
import { Activity } from 'react'

const Home = ({ premis, embedHome }) => {
	return (
		<div className='content' id='reis'>
			<div className='cap'>
				<p className='l1 up'>La Rifa de Reis</p>
				<p className='l3'>
					<Activity mode={premis.link_noticia !== '' && embedHome ? 'visible' : 'hidden'}>
						<a href={premis.link_noticia} target='_blank'>
							Comprova el teu número{' '}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								height='15px'
								viewBox='0 -960 960 960'
								width='15px'
								fill='#000'
							>
								<path d='m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z' />
							</svg>
						</a>
					</Activity>
				</p>
			</div>
			<div className='premis'>
				<div className='premi premi1'>
					<p className='l2'>Primer premi</p>
					<p className='l3'>2.000.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(premis.primer_premi)}</li>
					</ul>
				</div>

				<div className='premi premi2'>
					<p className='l2'>Segon premi</p>
					<p className='l3'>750.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(premis.segon_premi)}</li>
					</ul>
				</div>

				<div className='premi premi3'>
					<p className='l2'>Tercer premi</p>
					<p className='l3'>250.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(premis.tercer_premi)}</li>
					</ul>
				</div>

				<div className='premi premi4'>
					<p className='l2'>Terminacions de 4 xifres</p>
					<p className='l3'>3.500€</p>
					<ul className='p1'>
						<li className='l5'>{formatNumeric(premis.terminacio_4xifres_1)}</li>
						<li className='l5'>{formatNumeric(premis.terminacio_4xifres_2)}</li>
					</ul>
				</div>

				<div className='premi premi5'>
					<p className='l2'>Terminacions de 3 xifres</p>
					<p className='l3'>1.000€</p>
					<ul className='p1'>
						{[
							premis.terminacio_3xifres1,
							premis.terminacio_3xifres2,
							premis.terminacio_3xifres3,
							premis.terminacio_3xifres4,
							premis.terminacio_3xifres5,
							premis.terminacio_3xifres6,
							premis.terminacio_3xifres7,
							premis.terminacio_3xifres8,
							premis.terminacio_3xifres9,
							premis.terminacio_3xifres10,
							premis.terminacio_3xifres11,
							premis.terminacio_3xifres12,
							premis.terminacio_3xifres13,
							premis.terminacio_3xifres14,
						].map((num, i) => (
							<li key={i} className='l5'>
								{num}
							</li>
						))}
					</ul>
				</div>

				<div className='premi premi6'>
					<p className='l2'>Terminacions de 2 xifres</p>
					<p className='l3'>400€</p>
					<ul className='p1'>
						{[
							premis.terminacio_2xifres1,
							premis.terminacio_2xifres2,
							premis.terminacio_2xifres3,
							premis.terminacio_2xifres4,
							premis.terminacio_2xifres5,
						].map((num, i) => (
							<li key={i} className='l5'>
								{num}
							</li>
						))}
					</ul>
				</div>

				<div className='premi premi7'>
					<p className='l2'>Terminacions especials</p>
					<p className='l3'>200€</p>
					<ul className='p1'>
						{[premis.reintegrament_1er_premi, premis.reintegrament_1a, premis.reintegrament_2a].map(
							(num, i) => (
								<li key={i} className='l5'>
									{num}
								</li>
							)
						)}
					</ul>
				</div>
			</div>
		</div>
	)
}
export default Home
